<template>
  <div>
    <label for="privilegeTypeSelected"
      >Privilege Type<span v-if="required" class="required">*</span></label
    >
    <multiselect
      id="privilegeTypeSelected"
      v-model="privilegeType"
      :options="privilegeTypes"
      label="text"
      track-by="id"
      :disabled="setDisable"
      :loading="isLoading"
      :style="styleObject"
    >
    </multiselect>
  </div>
</template>

<script>
import PrivilegeService from "services/api/privilege.service";

export default {
  name: "PrivilegeTypesDropdown",
  props: ["value", "setDisable", "required", "styleObject"],
  data() {
    return {
      privilegeType: this.value,
      privilegeTypes: [],
      isLoading: false,
    };
  },
  async created() {
    await this.getPrivilegeTypes();
  },
  watch: {
    privilegeType(newValue) {
      this.$emit("setPrivilegeType", newValue);
    },
    value(newValue) {
      this.privilegeType = newValue;
    },
    privilegeTypes(newValue) {
      this.$emit("setPrivilegeTypes", newValue);
    },
  },
  methods: {
    async getPrivilegeTypes() {
      this.isLoading = true;
      try {
        await PrivilegeService.getListPrivilegeTypes()
          .then(async (res) => {
            const data = await res.data;
            this.privilegeTypes = data.privilegeTypes.map((s) => {
              return {
                id: s.code,
                text: s.name,
              };
            });
          })
          .catch((err) => {
            console.log("Error: ", err);
          });
      } catch (error) {
        console.log("Error: ", error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
